<template>
  <div class="stepper-component">
    <div class="stepper-section">
      <div
        v-for="(status, i) in statusList"
        :key="`${i}-${status.value}`"
        class="stepper-step"
        :class="{'active': status.active, 'negative-time': isLateness}"
      >
        <div class="step"></div>
        <div class="divider"></div>
        <div class="label">
          <span class="status">{{ status.title }}</span>
          <span class="time font-weight-medium"> {{ getStatusTime(status) }}</span>
          <span v-show="getDiffTime(status)"> / <span :class="isPositive ? 'positive-time' : 'negative-time'">{{ getDiffTime(status) }}</span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatIsoDateTimeAsTime } from '@/util/date-time-helper'

  const STATUS_CONFIRM = 'confirm'

  export default {
    name: 'Stepper',
    props: {
      isPositive: Boolean,
      isLateness: {
        type: Boolean,
        default: false,
      },
      statuses: {
        type: Array,
        default: () => ([]),
      },
      isPreorder: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        orderStatuses: [
          { value: 'new', title: 'Новый' },
          { value: 'confirm', title: 'Потверждён' },
          { value: 'preparing', title: 'Готовится' },
          { value: 'assembly', title: 'В сборке' },
          { value: 'readyForIssue', title: 'Готов к выдаче' },
          { value: 'inDelivery', title: 'Доставляется' },
          { value: 'completed', title: 'Завершён' },
        ],
        step: 1,
      }
    },
    computed: {
      statusList () {
        return this.orderStatuses.map((statusItem) => {
          const logStatus = this.findStatusInLog(statusItem.value)
          if (logStatus) {
            statusItem = { ...statusItem, ...logStatus }
            statusItem.active = true
          } else {
            statusItem.active = false
          }
          return statusItem
        })
      },
    },
    methods: {
      findStatusInLog (key) {
        return this.statuses.find(item => item.status === key)
      },
      isActive (status) {
        return !!this.statuses.find(item => item.status === status.value)
      },
      getStatusTime (status) {
        return formatIsoDateTimeAsTime(status.createdAt, '')
      },
      getDiffTime (status) {
        // У предзаказа время в «Подтверждён» это ожидание даты готовки, а не скорость работы.
        if (this.isPreorder && status.value === STATUS_CONFIRM) {
          return ''
        }

        const diff = status.diffTimePrevStatus

        if (!diff || diff < 5) {
          return ''
        }
        if (diff < 60) {
          return `${diff} сек`
        }
        return Math.round(diff / 60) + ' мин'
      },
    },
  }
</script>

<style lang="less" scoped>
.stepper-component {
  width: 100%;
  margin-top: 10px;
  position: relative;
  min-height: 42px;
  background-color: @color-secondary;

  /*&:after {
    content: '';
    position: relative;
    left: 0;
    bottom: 0;
    width: 100%;
    min-height: 42px;
    background-color: @color-secondary;
    z-index: -1;
  }*/

  .stepper-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    transform: translate(0, -50%);

    .stepper-step {
      position: relative;
      display: flex;
      align-items: center;
      height: 14px;
      flex: 1;
      &:before {
        position: absolute;
        left: -100%;
        content: '';
        height: 2px;
        width: 100%;
      }

      &:first-child {
        .label {
          left: 10px;
        }
        &:before {
          position: static;
          content: '';
          background-color: #1ee984;
          height: 3px;
          width: 29px;
          flex-basis: 29px;
          margin-right: -1px;
        }

        .media-xl({
          height: 18px;

          &:before {
            height: 3px;
          }

          &:first-child {
            .label {
              left: 18px;
            }
          }
        });
      }

      &.active {
        &.negative-time {
          &:before {
            background-color: #E91E63;
          }
          &:last-child {
            .divider {
              background-color: #E91E63;
              height: 3px;
            }
          }
          .step {
            background-color: #E91E63;
          }
        }
        &:before {
          background-color: #1ee984;
        }
        &:last-child {
          .divider {
            background-color: #1ee984;
            height: 3px;
          }
        }
        .step {
          background-color: #1ee984;
        }
        .label {
          color: #000000;
        }
        .positive-time {
          //color: #1ee984;
          color: #4caf50;
        }

        .negative-time {
          color: #e91e63;
        }
      }

      .divider {
        height: 1px;
        background-color: #dbdfe6;
        width: 100%;
        flex: 1;
        transition: background-color 0.2s ease, height 0.2s ease;
      }

      .step {
        width: 14px;
        height: 14px;
        background-color: #dbdfe6;
        border-radius: 50%;
        transition: background-color 0.2s ease;

        .media-xl({
          width: 18px;
          height: 18px;
        });
      }

      .label {
        position: absolute;
        top: calc(100% + 8px);
        font-size: 10px;
        color: #b8bdc6;
        line-height: 1;

        .media-xl({
          font-size: 12px;
          line-height: 1.1;
        });
      }
    }
  }
  //noinspection ALL
  .media-lg({
    display: flex;
    justify-content: flex-start;
    padding: 10px 20px;
    .stepper-section {
      position: relative;
      flex-direction: column;
      align-items: flex-start;
      transform: none;

      .stepper-step {
        padding: 10px 0;
        &:first-child {
          .label {
            padding-right: 5px;
          }
          &:before {
            display: none;
          }
        }
        &:before {
          display: block;
          position: absolute;
          left: 6px;
          top: -20px;
          content: '';
          height: 100%;
          width: 2px;
        }
        .label {
          margin-left: 10px;
          position: static;
          top: 0;
          left: calc(100% + 100px);
          font-size: 14px;
          color: #b8bdc6;
        }
        .step {
          width: 14px;
          height: 14px;
        }
      }
    }
  })
}
</style>
